import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ca } from '@cian/analytics';
import { EVENT_TWO_FACTOR_MAPPER } from './types';
import { getCianAnalyticsObjectPage } from '../../utils/tracking';
export function trackConfirmPhoneShown(source) {
  ca('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'verify_number_popup_show'
  }, source && {
    page: _objectSpread(_objectSpread({}, getCianAnalyticsObjectPage()), {}, {
      extra: {
        source: source
      }
    })
  }));
}
export function trackConfirmPhoneConfirmClick(source) {
  ca('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'verify_number_popup_click'
  }, source && {
    page: _objectSpread(_objectSpread({}, getCianAnalyticsObjectPage()), {}, {
      extra: {
        source: source
      }
    })
  }));
}
export function trackConfirmPhoneResendClick(source) {
  ca('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'verify_number_popup_retry'
  }, source && {
    page: _objectSpread(_objectSpread({}, getCianAnalyticsObjectPage()), {}, {
      extra: {
        source: source
      }
    })
  }));
}

/**
 * Открытие попапа двухфакторной авторизации
 */
export function trackTwoFactorPopupOpen(type) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Authorization',
    action: 'Open',
    label: "".concat(type ? EVENT_TWO_FACTOR_MAPPER[type] : '', "reg_popup")
  });
}

/**
 * Открытие попапа двухфакторной авторизации
 */
export function trackTwoFactorClose(type) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Authorization',
    action: 'Click',
    label: "".concat(type ? EVENT_TWO_FACTOR_MAPPER[type] : '', "close")
  });
}

/**
 * Открытие попапа после нескольких попыток ввода неправильного кода
 */
export function trackTwoFactorAttemptsExhaustedPopupOpen(type) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Authorization',
    action: 'Fail',
    label: "".concat(type ? EVENT_TWO_FACTOR_MAPPER[type] : '', "fatal")
  });
}
export function trackTwoFactorInvalid(type) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Authorization',
    action: 'Fail',
    label: "".concat(type ? EVENT_TWO_FACTOR_MAPPER[type] : '', "simple")
  });
}
export function trackTwoFactorWhatForClick(type) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Authorization',
    action: 'Click',
    label: "".concat(type ? EVENT_TWO_FACTOR_MAPPER[type] : '', "what_for")
  });
}
export function trackTwoFactorContinueClick(type) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Authorization',
    action: 'Click',
    label: "".concat(type ? EVENT_TWO_FACTOR_MAPPER[type] : '', "continue")
  });
}
export function trackTwoFactorCannotConfirmClick(type) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Authorization',
    action: 'Click',
    label: "".concat(type ? EVENT_TWO_FACTOR_MAPPER[type] : '', "cant_confirm")
  });
}
export function trackTwoFactorAttemptsExhaustedSupportClick(type) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Authorization',
    action: 'Click',
    label: "".concat(type ? EVENT_TWO_FACTOR_MAPPER[type] : '', "write_to_support")
  });
}
export function trackTwoFactorPhoneInputClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Authorization',
    action: 'Click',
    label: 'phone_input'
  });
}